import React, { FC, HTMLAttributes } from 'react';
import { Widget } from 'components';
import styles from './Statistics.module.scss';
import { t } from 'utils';
import AsideContainer from 'modules/userApps/WebhookLogs/components/AsideContainer/AsideContainer';

export interface IStatistics extends HTMLAttributes<HTMLDivElement> {
  installations: string;
  activeUsers: string;
}

const Statistics: FC<IStatistics> = (props) => {
  const { installations, activeUsers } = props;

  return (
    <AsideContainer className={styles.root} title={t('global.statistics')}>
      <Widget data={installations} title='app.statistics.installations' />
      <Widget data={activeUsers} title='app.statistics.activeUsers' />
    </AsideContainer>
  );
};

export default Statistics;
